<template>
	<div id="footer">
		<div class="footer-row">
			<img :src="appLogo" class="footer-img" alt="logo">
			<div class="footer-name">
				{{appName}}
			</div>
		</div>
	</div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$vw_design: 720;
// rem 单位换算：定为 75px 只是方便运算，750px-75px、640-64px、1080px-108px，如此类推
$vw_fontsize: 72; // iPhone 6尺寸的根元素大小基准值

@function rem($px) {
	@return ($px / $vw_fontsize) * 1rem;
}
#footer {
	height: rem(300);
	background: #282828;
	display: flex;
	align-items: flex-start;
	padding-top: rem(40);
	.footer-row {
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		.footer-img {
			width: rem(89);
			height: rem(89);
			margin-right: rem(29);
		}
		.footer-name {
			font-size: rem(41);
			font-weight: 500;
			color: #ffffff;
			line-height: rem(48);
		}
	}
}
</style>

<script>
export default {
	name: "Footer",
	props: {
    appName: String,
    appLogo: String
  }
};
</script>
